import React, { Component } from "react";

export interface IExternalValuationContext {
	setData<T>( key: string, data: T ): void;

	getData<T>( key: string ): T | undefined;
}

const defaultContext: IExternalValuationContext = {
	getData<T>( key: string ): T | undefined {
		return undefined;
	},
	setData<T>( key: string, data: T ): void {
	},
};

export const ExternalValuationContext = React.createContext( defaultContext );

interface Props {

}

interface State {
	[ key: string ]: any;
}

class ExternalValuationContextWrapper extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		this.state = {};
	}

	getData = ( key: string ) => {
		return this.state[ key ];
	};


	setData = ( key: string, data: any ) => {
		this.setState( {
			[ key ]: data,
		} );
	};

	render() {
		const { children, ...data } = this.props;
		return <ExternalValuationContext.Provider
			value={ {
				...this.state,
				...data,
				getData: this.getData,
				setData: this.setData,
			} }>
			{ children }
		</ExternalValuationContext.Provider>;
	}
}

export default ExternalValuationContextWrapper;
